import * as React from 'react';

export default function findByType(children: React.ReactElement[], component: React.ReactElement) {
  // @ts-expect-error ts-migrate(7034) FIXME: Variable 'result' implicitly has type 'any[]' in s... Remove this comment to see the full error message
  const result = [];

  React.Children.forEach(children, (child) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'displayName' does not exist on type 'str... Remove this comment to see the full error message
    if (child.type.displayName === component.name || child.type === component) {
      result.push(child);
    }
  });

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'result' implicitly has an 'any[]' type.
  return result[0];
}
